import { FC, memo } from 'react';

import { SalesStatsData } from '@type-def_iqfu/public/MarketData';

import { PublicPropertyType } from '@constants_iqfu';

import styles from '../trend_card_common.module.scss';

type Props = {
  displayData: SalesStatsData;
  areaName: string;
  propertyType: keyof typeof PublicPropertyType;
};

const AverageFloorPlan: FC<Props> = memo(({ displayData, areaName, propertyType }) => {
  return (
    <>
      {displayData.average_floor_plan.current.year ? (
        <div className={styles.container}>
          <div className={styles.trend_title}>
            {propertyType === 'mansion' ? (
              <span>
                売れた中古マンションの平均的な間取り
                <br />（{areaName}）
              </span>
            ) : (
              <span>
                {displayData.average_floor_plan.current.year}年に売れた中古一戸建て間取り
                <br />（{areaName}）
              </span>
            )}
          </div>

          <div className={styles.value_container}>
            <div className={styles.trend_value}>
              <p>{displayData.average_floor_plan.previous.year}年</p>
              <span className={styles.value}>{displayData.average_floor_plan.previous.value}</span>
            </div>
            <div className={styles.compare_arrow}></div>
            <div className={styles.trend_value}>
              <p>{displayData.average_floor_plan.current.year}年</p>
              <span className={styles.value}>{displayData.average_floor_plan.current.value}</span>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
});

AverageFloorPlan.displayName = 'AverageFloorPlan';

export default AverageFloorPlan;
